import { render, staticRenderFns } from "./FormTratamientoModal.vue?vue&type=template&id=1c0047b6&scoped=true"
import script from "./FormTratamientoModal.vue?vue&type=script&lang=js"
export * from "./FormTratamientoModal.vue?vue&type=script&lang=js"
import style0 from "./FormTratamientoModal.vue?vue&type=style&index=0&id=1c0047b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0047b6",
  null
  
)

export default component.exports